var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgYoutubeOutlinedIcon = function SvgYoutubeOutlinedIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.175 8.025C28.0265 7.43176 27.7241 6.88821 27.2983 6.44926C26.8725 6.0103 26.3384 5.69148 25.75 5.525C23.6 5 15 5 15 5C15 5 6.39998 5 4.24998 5.575C3.66154 5.74148 3.12745 6.0603 2.70167 6.49926C2.27588 6.93821 1.97347 7.48176 1.82498 8.075C1.4315 10.2569 1.23903 12.4704 1.24998 14.6875C1.23596 16.9213 1.42844 19.1516 1.82498 21.35C1.98868 21.9248 2.29787 22.4477 2.72266 22.8681C3.14746 23.2885 3.67351 23.5923 4.24998 23.75C6.39998 24.325 15 24.325 15 24.325C15 24.325 23.6 24.325 25.75 23.75C26.3384 23.5835 26.8725 23.2647 27.2983 22.8257C27.7241 22.3868 28.0265 21.8432 28.175 21.25C28.5654 19.0845 28.7579 16.8879 28.75 14.6875C28.764 12.4537 28.5715 10.2234 28.175 8.025V8.025Z",
    stroke: "#A4A3EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1875 18.7751L19.375 14.6876L12.1875 10.6001V18.7751Z",
    stroke: "#A4A3EE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYoutubeOutlinedIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/youtube-outlined-icon.a14f4fb6.svg";
export { ForwardRef as ReactComponent };